import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <Toaster 
        data-testid="global-toaster" 
        richColors 
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: 'Manrope, sans-serif',
          }
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
